export const KEY_API_TOKEN = 'cove-api-token';
export const KEY_EMAIL = 'cove-email';
export const KEY_PLUGIN_AUTHORIZATION = 'cove-plugin-key';
export const KEY_PROCORE_PROJECT_ID = 'procore-project-id';
export const PARAM_PROCORE_PROJECT_ID = 'procoreProjectId';
